export default __webpack_public_path__ + "static/media/crop_type_cotton.a7316689.jpg";